import dayjs from "dayjs";
import { ComboBoxCustom, ITableElement } from "shared/components";
import { columnsUsersTfeType } from "../types/columsUsersTfe.types";

export const  columnsGridUsersDrAct = (userRoles: any[], handleRoleAssignment?: any): ITableElement<columnsUsersTfeType>[] => {

  const columnsTable = [
    {
      field: 'name',
      headerName: 'Nombre',
      minWidth: 240,
      renderCell(params: columnsUsersTfeType) {
        return (<>{params.name ?? ''}</>)
        },
    },
    {
      field: 'email',
      headerName: 'Email',
      minWidth: 240,
      renderCell(params: columnsUsersTfeType) {
        return (<>{params.email ?? ''}</>)
      },
    },
  ];
  return columnsTable
} 
    